import { Pipe, PipeTransform } from '@angular/core';
import { OrgStatus } from '../types/enumerated-types/orgStatus';

@Pipe({
    name: 'formStatus',
    standalone: false
})
export class FormStatusPipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case OrgStatus.CR: return 'CR';
      case OrgStatus.NOTSTARTED: return 'NOT STARTED';
      case OrgStatus.CFO: return 'CFO';
      case OrgStatus.DIR: return 'DIR';
      case OrgStatus.LP: return 'LP';
      case OrgStatus.LR: return 'LR';
      case OrgStatus.FINAL: return 'FINAL';
      case OrgStatus.DRAFT: return 'DRAFT';
      case OrgStatus.RR: return 'RR';
      case OrgStatus.RETURNED: return 'RETURNED';
      case OrgStatus.NOTREQUIRED: return 'NOT REQUIRED';
      default: return '';
    }
  }
}
